import React from 'react';
import styled, { css } from 'styled-components';
import { toRem } from './Utils';

const StarGraphic = ({ active }: { active?: boolean }) => {
    return <svg viewBox="0 0 64 64">
        {!active && <path fill="currentColor" d="M46,55c-0.366,0-0.732-0.1-1.057-0.302L32,46.648l-12.943,8.05c-0.68,0.423-1.546,0.399-2.201-0.058	c-0.656-0.458-0.977-1.262-0.813-2.045l3.16-15.264L7.687,27.315c-0.602-0.523-0.835-1.354-0.594-2.113	c0.24-0.76,0.91-1.304,1.703-1.385l15.281-1.562l6.087-14.05C30.481,7.474,31.203,7,32,7s1.519,0.474,1.835,1.205l6.087,14.05	l15.281,1.562c0.793,0.081,1.463,0.625,1.703,1.385c0.241,0.76,0.008,1.59-0.594,2.113L44.798,37.331l3.16,15.264	c0.163,0.783-0.157,1.587-0.813,2.045C46.802,54.879,46.401,55,46,55z M32,42.293c0.366,0,0.732,0.101,1.057,0.302l10.039,6.244	l-2.451-11.843c-0.147-0.708,0.1-1.44,0.646-1.914l8.915-7.754L38.35,26.116c-0.721-0.074-1.345-0.531-1.632-1.195L32,14.031	l-4.718,10.89c-0.287,0.664-0.911,1.121-1.632,1.195l-11.855,1.211l8.915,7.754c0.546,0.474,0.793,1.206,0.646,1.914l-2.451,11.843	l10.039-6.244C31.268,42.394,31.634,42.293,32,42.293z" />}
        {active && <path fill="currentColor" d="M46.0002 54.9999C45.6342 54.9999 45.2682 54.8999 44.9432 54.6979L32.0002 46.648L19.0572 54.6979C18.3772 55.1209 17.5112 55.0969 16.8562 54.6399C16.2002 54.1819 15.8792 53.3779 16.0432 52.5949L19.2032 37.331L7.68721 27.315C7.08521 26.792 6.85221 25.961 7.09321 25.202C7.33321 24.442 8.00321 23.898 8.79621 23.817L24.0772 22.255L30.1642 8.205C30.4812 7.474 31.2032 7 32.0002 7C32.7972 7 33.5192 7.474 33.8352 8.205L39.9222 22.255L55.2032 23.817C55.9962 23.898 56.6662 24.442 56.9062 25.202C57.1472 25.962 56.9142 26.792 56.3122 27.315L44.7982 37.331L47.9582 52.5949C48.1212 53.3779 47.8012 54.1819 47.1452 54.6399C46.8022 54.8789 46.4012 54.9999 46.0002 54.9999ZM43.89 48.839C6.63455 25.6671 35.1541 6.62784 43.89 48.839Z" />}
    </svg>;
};

const StarFrame = styled.div<{ size?: any, clickable: boolean }>`
    width: ${p => toRem(p.size || 2)};
    height: ${p => toRem(p.size || 2)};
    cursor: pointer;

    svg {
        transition: transform .15s ease-in-out;
    }

    ${p => p.clickable && css`
    &:hover {
        svg {
            transform: scale(1.2);
        }
    }
    `}

    &:active {
        svg {
            transform: scale(1);
        }
    }
`;

type StarRatingProps = {
    size?: any,
    active?: boolean,
    onClick?: () => void,
};

export const Star = React.memo<StarRatingProps>(({ size, active, onClick }) => {
    return <StarFrame clickable={!!onClick} {...{ size, onClick }}>
        <StarGraphic active={active} />
    </StarFrame>;
});
